import { render } from "./LocalizedDate.vue?vue&type=template&id=234e8951"
import script from "./LocalizedDate.vue?vue&type=script&lang=js"
export * from "./LocalizedDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__